module.exports = __webpack_public_path__ + "img/users-solid updated.477f876c.svg";